<div class="tooltip shadow" [style.width.px]="_width" class="{{class}}" [ngClass]="{'top': position == 'top', 'right': position == 'right', 'bottom': position == 'bottom', 'left': position == 'left'}" #tooltip [style.top.px]="top" [style.left.px]="left">
    <div class="arrow shadow" #tooltipArrow [style.left.px]="arrow_left"></div>
    <div class="tooltip-body-title" [innerHTML]="title" style="max-width: 300px; word-wrap: break-word;" ></div>
</div>
